import script from "./multi-popup-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./multi-popup-layout.vue?vue&type=script&setup=true&lang=js"

import "./multi-popup-layout.vue?vue&type=style&index=0&id=6312d36c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6312d36c"]])

export default __exports__